/**
 * NFC-normalize and strip everything outside Unicode letters, digits, the
 * regular space, dots, dashes, and underscores. Path separators become
 * single dashes; all control and format characters (tabs, newlines, ZWJ,
 * etc.) are removed.
 *
 * Preserves Hangul, CJK, kana, and other non-Latin scripts so international
 * project / asset names survive filesystem-level filename sanitization on
 * download. Call sites typically follow this with `.replace(/ +/g, '-' | '_')`
 * and an empty-string fallback.
 */
export function sanitizeUnicodeFilename(name: string): string {
  return name
    .normalize('NFC')
    .replace(/[\p{Cc}\p{Cf}]/gu, '')
    .replace(/[\\/]/g, '-')
    .replace(/[^\p{L}\p{N} ._-]/gu, '')
}
